import React, { useState, useRef, useEffect } from 'react';

const ChatPopup = ({ 
  isOpen, 
  onClose, 
  chatMessages, 
  onSendMessage, 
  playerColor,
  players 
}) => {
  const [chatInput, setChatInput] = useState('');
  const chatMessagesRef = useRef(null);

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (chatInput.trim()) {
      onSendMessage(chatInput.trim());
      setChatInput('');
    }
  };

  const isMyMessage = (message) => {
    const currentPlayer = Object.values(players).find(p => p.color === playerColor);
    return currentPlayer && message.playerId === currentPlayer.id;
  };

  if (!isOpen) return null;

  return (
    <div className="chat-overlay">
      <div className="chat-popup">
        <div className="chat-popup-header">
          <h3>Game Chat</h3>
          <button className="chat-close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="chat-messages" ref={chatMessagesRef}>
          {chatMessages.length === 0 ? (
            <div className="no-messages">No messages yet. Say hello!</div>
          ) : (
            chatMessages.map((message) => (
              <div 
                key={message.id} 
                className={`chat-message ${isMyMessage(message) ? 'own-message' : ''}`}
              >
                <div className="message-header">
                  <span className="sender">{message.playerName}</span>
                  <span className="timestamp">
                    {new Date(message.timestamp).toLocaleTimeString()}
                  </span>
                </div>
                <div className="message-text">{message.text}</div>
              </div>
            ))
          )}
        </div>
        
        <form onSubmit={handleSendMessage} className="chat-input-container">
          <input
            type="text"
            value={chatInput}
            onChange={(e) => setChatInput(e.target.value)}
            placeholder="Type a message..."
            className="chat-input"
            maxLength="200"
          />
          <button type="submit" className="send-button" disabled={!chatInput.trim()}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatPopup;
